import {
  SfMediaImage, SfItem, SfLink,
  SfLocalizeService,
  SfRubric, SfSection, SfTag, SfBanner
} from '@app/sf-lib/public_api';
import { SomPage } from './page.model';
import { TranslateService } from '@ngx-translate/core';
import { inject } from '@angular/core';

export class SomMenuPageArticlePage extends SomPage implements SfItem, SfBanner {

  /** Unique ID from server */
  public nid: number;
  
  /** Duplicate ID. When a node is duplicated we should show this ID in url  */
  public duplication_id: number;

  /** Type from server */
  public type: string;

  /** Title */
  public title: string;

  /** Path alias information */
  public path: {
    alias: string;
  };

  /** Main image of the article */
  public cover: SfMediaImage;

  /** Main image of the article for mobile */
  public smallcover: SfMediaImage;

  /** Should item be displayed big or small */
  public display: boolean;

  public rubric: SfRubric;

  public sections: SfSection[];

  public tag: SfTag;

  public iconName: string;

  public get link(): SfLink {
    let alias = `${this.nid}`;
    if (this.path && this.path.alias) {
      alias = this.path.alias.replace(/\//g, '');
    }
    return {
      is_external: false,
      label: `${this.translate.instant('PRODUCT.MORE_INFORMATION')}`,
      url: `${this.localize.instant(this.baseUrl)}/${alias}/${this.nid}/${this.duplication_id}`
    };
  }
  public set link(value: SfLink) {
    return;
  }

  /** SfBanner uppertitle */
  public get uppertitle(): string {
    if (this.tag && this.tag.name) {
      return this.tag.name && this.tag.name[0] && this.tag.name[0]['value'] ? this.tag.name[0]['value'] : this.tag.name;
    } else {
      return null;
    }
  }

  /** SfBanner background */
  public get background(): SfMediaImage {
    return this.cover;
  }

  /** SfBanner smallbackground */
  public get smallbackground(): SfMediaImage {
    return this.smallcover;
  }

  private readonly baseUrl = '/menu-page/article';

  private readonly localize = inject(SfLocalizeService);
  private readonly translate = inject(TranslateService);

  public constructor() {
    super();
  }

  /**
   * Custom function used by JSON.stringify
   * This prevent JSON.stringify to throw an error on circular
   * references
   *
   * @param {string} nm Name of the property
   * @returns {string}
   * @memberof SomCorporateArticlePage
   */
  public toJSON(nm: string) {
    const newArticle = {
      nid: this.nid,
      duplication_id: this.duplication_id,
      type: this.type,
      title: this.title,
      cover: this.cover,
      display: this.display,
      rubric: this.rubric,
      sections: this.sections,
      tag: this.tag,
      path: this.path,
      iconName: this.iconName,
      link: this.link,
      uppertitle: this.uppertitle,
      background: this.background,

      lang: this.lang,
      content: this.content,
      meta_title: this.meta_title,
      meta_description: this.meta_description,
      meta_keywords: this.meta_keywords,
    };
    return newArticle;
  }
}
